import {greys} from '../styles/colorStyles';

// Properties which are the same color in all themes. Access with
// theme.constants
export const themeConstants = {
  black: greys.black,
  white: greys.white,
} as const;
